import React, { useState } from 'react';
import { IoCallOutline } from "react-icons/io5";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { TiMessages } from "react-icons/ti";

const ContactUs = () => {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const cardData = [
    { 
      icon: (
        <a href="tel:+919175978889" style={styles.link}>
          <IoCallOutline style={styles.icon} />
        </a>
      ), 
      title: "Call Us", 
      description: "Monday to Saturday",
      additionalInfo: "+91 9175978889"
    },
    { 
      icon: (
        <a href="mailto:admin@rapidsoftlogic.com" style={styles.link}>
          <MdEmail style={styles.icon} />
        </a>
      ), 
      title: "Email Us", 
      description: "Weekdays: 10:30 AM — 7 PM IST",
      additionalInfo: "admin@rapidsoftlogic.com"
    },
    { 
      icon: (
        <a href="https://chat.whatsapp.com/I0ZGbLs0K5Q8mMFSNmfYOZ" target="_blank" rel="noopener noreferrer" style={styles.link}>
          <TiMessages style={styles.icon} />
        </a>
      ), 
      title: "Community Forum", 
      description: "Monday to Saturday",
      additionalInfo: "Response time: 24 hours"
    },
    {
      icon: (
        <MdLocationOn style={styles.icon} />
      ),
      title: "Our Office",
      description: "Visit Us",
      additionalInfo: (
        <>
          607, 608 B-wing, Lokmat Bhavan,<br />
          Lokmat Square, Ramdaspeth,<br />
          Nagpur, Maharashtra 440012
        </>
      )
    }
  ];

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "fabb3cfb-5cb8-4f83-81ae-b1c5caf0797a");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
      setFormValues({
        name: '',
        email: '',
        phone: '',
        message: '',
      });
    } else {
      console.error("Error", res);
    }
  };

  return (
    <div style={styles.contactUs}>
      <div style={styles.cards}>
        {cardData.map((card, index) => (
          <div
            key={index}
            style={{
              ...styles.card,
              ...(hoverIndex === index ? styles.cardHover : {}),
            }}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <div className="icon-container">{card.icon}</div>
            <p style={styles.cardP}><strong>{card.title}</strong></p>
            <p style={styles.cardP}>{card.description}</p>
            <p style={styles.cardP}>{card.additionalInfo}</p>
          </div>
        ))}
      </div>

      <div style={styles.contactFormSection}>
        <form onSubmit={onSubmit} style={styles.contactForm}>
          <h3>We'd love to hear from you</h3>
          <div style={styles.formGroup}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              style={styles.input}
              value={formValues.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div style={styles.formGroup}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              style={styles.input}
              value={formValues.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div style={styles.formGroup}>
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              style={styles.input}
              value={formValues.phone}
              onChange={handleInputChange}
              required
            />
          </div>
          <div style={styles.formGroup}>
            <textarea
              name="message"
              placeholder="Message"
              style={styles.textarea}
              value={formValues.message}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
          <button type="submit" style={styles.button}>Send Message</button>
        </form>
      </div>

      <style>{`
        .icon-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background-color: #fff;
          transition: all 0.5s ease-in-out;
        }

        .icon-container:hover {
          transform: rotateY(360deg);
        }

        @media (max-width: 768px) {
          .icon-container {
            width: 80px;
            height: 80px;
          }
        }

        @media (max-width: 480px) {
          .icon-container {
            width: 60px;
            height: 60px;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  contactUs: {
    textAlign: 'center',
    padding: '20px',
  },
  cards: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '20px',
    flexWrap: 'wrap',
  },
  card: {
    width: '300px',
    minHeight: '250px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #ccc',
    borderRadius: '10px',
    transition: 'all 0.3s ease-in-out',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    background: 'white',
    cursor: 'pointer',
    margin: '10px',
    padding: '15px',
  },
  cardHover: {
    minHeight: '300px',
    borderRadius: '20px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
    background: '#F0F8FF',
  },
  cardP: {
    marginTop: '5px',
    color: 'black',
  },
  icon: {
    fontSize: '40px',
    marginBottom: '10px',
    color: '#1A73E8',
  },
  contactFormSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '40px',
    padding: '20px',
  },
  contactForm: {
    width: '100%',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px',
    border: '1px solid #ccc',
    borderRadius: '10px',
    background: '#fff',
  },
  formGroup: {
    marginBottom: '15px',
    width: '100%',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  textarea: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    height: '100px',
  },
  button: {
    padding: '10px 20px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#1A73E8',
    color: 'white',
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
};

export default ContactUs;
